import React, { useState } from 'react'
import './ConfirmationModal.css'
import { Btn } from "../../components";

type Props = {
  title: string
  confirmBtnLabel?: string
  cancelBtnLabel?: string
}
export function useConfirmationModal() {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isConfirmed, setIsConfirmed] = useState<boolean>(false)

  const showConfirmationModal = () => {
    setIsConfirmed(false)
    setIsOpen(true)
  }
  const confirm = () => {
    setIsOpen(false)
    setIsConfirmed(true)
  }
  const dismiss = () => {
    setIsOpen(false)
    setIsConfirmed(false)
  }

  const ConfirmationModalComponent: React.FC<Props> = ({ title, cancelBtnLabel, confirmBtnLabel }) => isOpen ?
    <div className="modal-backdrop">
      <div className="confirmation-modal-container slide-in-bck-center-delayed-250ms">
        <div className="modal-header">
          <div className="modal-title">{title}</div>
        </div>
        <div className="modal-content">
          <div className="flex flex-row justify-between">
            <Btn className="btn-base-100" icon="fa-ban" children={cancelBtnLabel || 'Zrušit'} onClick={dismiss} />
            <Btn className="btn-error" icon="fa-trash-can" children={confirmBtnLabel || 'OK'} onClick={confirm} />
          </div>
        </div>

      </div>
    </div>
    : null

  return { showConfirmationModal, ConfirmationModalComponent, isConfirmed }
}
